//TODO Place auto-generated types here plus any other commonly used type for the feature

import type { SiteRead } from "../../site-management/services/siteTypes";

export const contractTagTypes: ContractTagType[] = ["ContractList"];
export type ContractTagType = "ContractList";
export type ContractsListApiResponse = /** status 200  */ PaginatedContractListRead;
export type ContractsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  sort?: string;
};
export type ContractsCreateApiResponse = /** status 201  */ ContractRead;
export type ContractsCreateApiArg = {
  createRequest: ContractRequest;
};
export type ContractsRetrieveApiResponse = /** status 200  */ ContractRead;
export type ContractsRetrieveApiArg = {
  /** A unique integer value identifying this power contract. */
  id: number;
};
export type ContractsUpdateApiResponse = /** status 200  */ ContractRead;
export type ContractsUpdateApiArg = {
  /** A unique integer value identifying this power contract. */
  id: number;
  updateRequest: ContractRequest;
};
export type ContractsPartialUpdateApiResponse = /** status 200  */ ContractRead;
export type ContractsPartialUpdateApiArg = {
  /** A unique integer value identifying this power contract. */
  id: number;
  patchRequest: PatchedContractRequest;
};
export type ContractsDestroyApiResponse = unknown;
export type ContractsDestroyApiArg = {
  /** A unique integer value identifying this power contract. */
  id: number;
};
export type Contract = {
  power_provider_name: string;
  import_day_kwh_rate: string;
  import_night_kwh_rate: string;
  export_kwh_rate: string;
  day_start: string;
  night_start: string;
  contract_start_date: string;
  contract_end_date: string;
};
export type ContractRead = {
  id: number;
  site: SiteRead;
  created_at: string;
  updated_at: string;
  power_provider_name: string;
  import_day_kwh_rate: string;
  import_night_kwh_rate: string;
  export_kwh_rate: string;
  day_start: string;
  night_start: string;
  contract_start_date: string;
  contract_end_date: string;
};
export type PaginatedContractList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Contract[];
};
export type PaginatedContractListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ContractRead[];
};
export type ContractRequest = {
  power_provider_name: string;
  import_day_kwh_rate: string;
  import_night_kwh_rate: string;
  export_kwh_rate: string;
  day_start: string;
  night_start: string;
  contract_start_date: string;
  contract_end_date: string;
};
export type PatchedContractRequest = {
  power_provider_name?: string;
  import_day_kwh_rate?: string;
  import_night_kwh_rate?: string;
  export_kwh_rate?: string;
  day_start?: string;
  night_start?: string;
  contract_start_date?: string;
  contract_end_date?: string;
};
